import { useEffect, useRef, useState } from 'react';
import { LANGUAGE_META, SUPPORTED_LANGUAGES, useLanguage } from '@/contexts/LanguageContext';

export const LanguageSelector = () => {
  const { language, setLanguage, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (event: PointerEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) setOpen(false);
    };
    window.addEventListener('pointerdown', close);
    return () => window.removeEventListener('pointerdown', close);
  }, [open]);

  return (
    <div className={`language-selector ${open ? 'is-open' : ''}`} ref={containerRef}>
      <button type="button" className="language-selector-current"
        aria-label={`${t('language.selector')}: ${LANGUAGE_META[language].label}`} aria-expanded={open}
        onClick={() => setOpen((value) => !value)}>
        <img src={LANGUAGE_META[language].flag} alt="" draggable={false} />
      </button>
      {open && (
        <div className="language-selector-list" role="menu" aria-label={t('language.selector')}>
          {SUPPORTED_LANGUAGES.filter((code) => code !== language).map((code) => (
            <button type="button" role="menuitem" key={code}
              aria-label={`${t('language.changeTo')} ${LANGUAGE_META[code].label}`}
              onClick={() => { setLanguage(code); setOpen(false); }}>
              <img src={LANGUAGE_META[code].flag} alt="" draggable={false} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
